// extracted by mini-css-extract-plugin
export default {"libraryIcon":"LibraryIcon-module__libraryIcon_LESTn","mobile-ui":"mobile-ui"};